module.exports = __webpack_public_path__ + "static/media/01_solar_canopy-3_1.18b6f516.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/01_solar_canopy-3_1.jpg
// module id = 1175
// module chunks = 0